import { useCallback } from "react"

import { transport, useTransportQueryUtils } from "@/transport"

export function useInvalidateConversationsResultsTransport() {
  const transportUtils = useTransportQueryUtils()

  return useCallback(
    () =>
      transportUtils.invalidateOperation(
        transport.operations.queryUploadedConversationKeyset,
      ),
    [transportUtils],
  )
}
